import { type CityProfile } from '@core/city-profile/city-profile'

// the Puebla demo profile — fifth demo city alongside Lyon, Lisbon, Torino and Mexico City.
// centre is the Zócalo (Plaza de la Constitución) of Puebla de Zaragoza ; the UI runs in Spanish,
// exactly like the Mexico City build (both the frontend dictionaries and the gwapi dictionary
// already carry 'es', so a demopuebla build is localised out of the box).
// the dataset covers the Zona Metropolitana Puebla-Tlaxcala, from Cholula to Chachapa and from
// Cuautlancingo to Valsequillo — a tighter footprint than CDMX, hence the slightly closer zoom.
export const kPueblaProfile: CityProfile = {
  id: 'puebla',
  displayName: 'Movilidad Puebla',
  brandLines: ['Movilidad', 'Puebla'],
  center: [-98.1983, 19.0433],
  zoom: 11.8,
  supervisionZoom: 11.2,
  locale: 'es-mx',
  tz: 'America/Mexico_City',
  currency: '$',
}
